"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WHITELIST_SUBGRAPH_URL = exports.CONFIG_MANAGER_SUBGRAPH_URL = exports.XIMX_SUBGRAPH_URL = exports.BLOCKS_SUBGRAPH_URL = exports.LENDING_VAULT_SUBGRAPH_URL = exports.IMPERMAX_CHEF_SUBGRAPH_URL = exports.IMPERMAX_SUBGRAPH_URL = void 0;
const types_1 = require("./types");
exports.IMPERMAX_SUBGRAPH_URL = {
    [types_1.Networks.Ropsten]: {},
    [types_1.Networks.Mainnet]: {
        [types_1.Factory.V2V1]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/Dn5WZv53V1K8LrKqqYn29hhuhpwfuFfmsrsTqMgFjrD3']
    },
    [types_1.Networks.Polygon]: {
        [types_1.Factory.V2V1_1]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/F3BfecWo2by5QKrwhkXwuXjyLZnQqJ1wqoejwe67KuyG'],
        [types_1.Factory.V2V2]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/5JbuAaWwyRm78yWpRCJJS217hXXft59g9MbsjTTZnYQa'],
        [types_1.Factory.SOLV2]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/Giwg5N4SCehmUzNwXtAQZnZvUuTjcp7cr3nzUZosRDFU'],
        [types_1.Factory.SOL_STABLE]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/EWckMdMiZeDSGHxq2V8gZBDF549Xjr9iKkPvisqckF11'],
    },
    [types_1.Networks.Arbitrum]: {
        [types_1.Factory.V2V1_1]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/3PMyaq269mDMwhJ7E285RYD1r43x996b6xZmJSCGvtkm'],
        [types_1.Factory.V2V2]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/BkMRb8mR5zgCbjFSgau6s27pnANhR6k64RGVKUbWaZdY'],
        [types_1.Factory.SOLV2]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/AdLbcSfG6JnpZ7RDdHNHq3bJ21waGnRi7AJ5x3YFGYFo'],
    },
    [types_1.Networks.Avalanche]: {
        [types_1.Factory.V2V1_2]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/HXhHppWXhFqgLfdmTahFj2x7F5Xq8BwADxGY3nbCUAwr'],
        [types_1.Factory.V2V2]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/8Gz5ZGyRkSA7WBrSteeyez39AgZQsoEbtXe8GtHD7JMQ'],
        [types_1.Factory.SOLV2]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/78e6cZp11r2coLx8YYo5y4AqzEhQXYT6sw3Bg5Tiy5XU'],
    },
    [types_1.Networks.Mantle]: {
        [types_1.Factory.V2V2]: ['https://subgraph-api.mantle.xyz/subgraphs/name/impermax-finance/impermax-mantle-v2']
    },
    [types_1.Networks.Moonriver]: {
        [types_1.Factory.V2V1_2]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/6NqkDBwiybbB3BjErF6QGGYJCqzyhVFKpNYHQTN2j8Jn']
    },
    [types_1.Networks.Aurora]: {},
    [types_1.Networks.Cronos]: {},
    [types_1.Networks.Fantom]: {
        [types_1.Factory.SOLV1_2]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/8vssJypWas5oenzsjjQq1yLqMe7FRt2evcqZdzCNEWt7'],
        [types_1.Factory.SOLV2]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/DJ2bTPinDji7Kwev3WjyfxRo487tJHiEEMEo8kmTMT8F'],
        [types_1.Factory.V2V2]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/DPk9E2c9fLKF8N6rN3jcyvSrEq4VEgjdeeJcnaEKAngG']
    },
    [types_1.Networks.Canto]: {
        [types_1.Factory.SOLV2]: ['https://api.impermax.finance/subgraphs/name/impermax-finance/impermax-canto-solv2'],
    },
    [types_1.Networks.ZksyncEra]: {
        [types_1.Factory.SOLV2]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/8YSS88X8ChDw1QvuAMtxjezSXNiYer9k9d3Uu8XFLHzX'],
    },
    [types_1.Networks.Harmony]: {},
    [types_1.Networks.Moonbeam]: {},
    [types_1.Networks.Sxnetwork]: {},
    [types_1.Networks.Blast]: {
        [types_1.Factory.SOLV2]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/4FDikpVjE2XnDJ5QcpQ1YJXWcUDiAgE7x8ErtsHh33UB'],
        [types_1.Factory.V2V2]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/6xkrXFPJ4wqh9cy9ayP19WGr2wZVSMP3FniMjcW2LUG4'],
        [types_1.Factory.SOL_STABLE]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/CfJnk2rt4fUs71dvJJk21dbSS4dshKFWjfLsCceTXNBa']
    },
    [types_1.Networks.Base]: {
        [types_1.Factory.SOLV2]: [
            'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/EjB7Dsb7WnfFf1NPPr5rbGnGmk2Jqs42nWPVHjv9997u',
            'https://base-factory-production.up.railway.app/'
        ],
        [types_1.Factory.SOL_STABLE]: [
            'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/9wN7xinUXf8RP8dbwpkzSmCNQKfz31FDpvPEvTQyT8SL',
            'https://base-factory-production.up.railway.app/'
        ],
        [types_1.Factory.V2V2]: [
            'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/B7xsBeef3FohKaFPcsAsviyLKaWXTqcSELjAsPj2B7iW',
            'https://base-factory-production.up.railway.app/'
        ],
    },
    [types_1.Networks.Scroll]: {
        [types_1.Factory.SOLV2]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/9HL6kLRt3AbQsprTvk7KZdaHunJ5GGsLdYWd27nNfCFC'],
        [types_1.Factory.SOL_STABLE]: ['https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/C42ymmkDArE1T5wdYKwao6mntqNSjP2E34TeGusiF3sk']
    },
    [types_1.Networks.Optimism]: {
        [types_1.Factory.SOLV2]: [
            'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/74C2pMzH3wNKf38PNheGZfSiY4FzmJoKiGtHLYa7oD2s',
            'https://optimism-factory-production.up.railway.app/'
        ]
    },
    [types_1.Networks.Real]: {
        [types_1.Factory.SOL_STABLE]: ['https://api.goldsky.com/api/public/project_cm2d5q4l4w31601vz4swb3vmi/subgraphs/impermax-finance/impermax-real-v2-stable/gn'],
        [types_1.Factory.SOLV2]: ['https://api.goldsky.com/api/public/project_cm2rhb30ot9wu01to8c9h9e37/subgraphs/impermax-real-solv2/3.0/gn']
    },
    [types_1.Networks.Sonic]: {
        [types_1.Factory.SOLV2]: [
            'https://sonic-factory-production.up.railway.app/',
            'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/HK9BA4oFp1xaoQW7YVP4m2nbxX7q2bQCZWNPKBtudtZR'
        ],
        [types_1.Factory.SOL_STABLE]: [
            'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/61ZJXkM5uRGntP1HZkmH4iaKRzsf1BBhQdZYi9euLkpM'
        ]
    },
    [types_1.Networks.Linea]: {
        [types_1.Factory.SOLV2]: [
            'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/AyFSeFRAtUm4aY3cb1zTJqoMjcgSNrRipucuSxkEZ1v9'
        ],
        [types_1.Factory.SOL_STABLE]: [
            'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/Ah5k6hzS9YicNHWuA4Uts9MQQQGbPLDtwD8tYjKaX8Ls'
        ]
    }
};
exports.IMPERMAX_CHEF_SUBGRAPH_URL = {
    [types_1.Networks.Ropsten]: '',
    [types_1.Networks.Mainnet]: '',
    [types_1.Networks.Polygon]: 'https://api.studio.thegraph.com/query/46041/impermax-chef-polygon/v0.0.1',
    //[Networks.Arbitrum]: 'https://api.thegraph.com/subgraphs/name/impermax-finance/impermax-chef-arbitrum',
    [types_1.Networks.Arbitrum]: 'https://api.studio.thegraph.com/query/46041/impermax-chef-arbitrum-ibex/v0.0.1',
    [types_1.Networks.Avalanche]: 'https://api.studio.thegraph.com/query/46041/impermax-chef-avalanche/v0.0.1',
    [types_1.Networks.Moonriver]: 'https://api.studio.thegraph.com/query/46041/impermax-chef-moonriver/v0.0.1',
    [types_1.Networks.Fantom]: 'https://api.studio.thegraph.com/query/46041/impermax-chef-fantom/v0.0.1',
    [types_1.Networks.Aurora]: '',
    [types_1.Networks.Cronos]: '',
    [types_1.Networks.Harmony]: '',
    [types_1.Networks.Moonbeam]: '',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Canto]: '',
    [types_1.Networks.ZksyncEra]: '',
    [types_1.Networks.Blast]: '',
    [types_1.Networks.Base]: '',
    [types_1.Networks.Mantle]: '',
    [types_1.Networks.Scroll]: '',
    [types_1.Networks.Optimism]: '',
    [types_1.Networks.Real]: '',
    [types_1.Networks.Sonic]: '',
    [types_1.Networks.Linea]: '',
};
exports.LENDING_VAULT_SUBGRAPH_URL = {
    [types_1.Networks.Ropsten]: '',
    [types_1.Networks.Mainnet]: '',
    [types_1.Networks.Polygon]: 'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/BNWJQpKBT24mYzLYZ7hdBiJpvfBoEwjSemNkQ1Rryknp',
    [types_1.Networks.Arbitrum]: 'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/BhmcL1CZmw9hftXPviiTeMY7kghbbkpHZtpiHXWVhNNN',
    [types_1.Networks.Avalanche]: '',
    [types_1.Networks.Moonriver]: '',
    [types_1.Networks.Fantom]: '',
    [types_1.Networks.Aurora]: '',
    [types_1.Networks.Cronos]: '',
    [types_1.Networks.Harmony]: '',
    [types_1.Networks.Moonbeam]: '',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Canto]: '',
    [types_1.Networks.ZksyncEra]: '',
    [types_1.Networks.Blast]: 'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/8UbzkWkh1zqWhkgkomcVAVR7tmvDNq9LUtfmvRwtDQTh',
    [types_1.Networks.Base]: 'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/2TdbQKGWPRHUwuHJgxQzh8kZ7FVpBgZaFtnbjTS6iYng',
    [types_1.Networks.Mantle]: '',
    [types_1.Networks.Optimism]: '',
    [types_1.Networks.Real]: '',
    [types_1.Networks.Scroll]: 'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/BaPMX2ubiRZ4ujqTFmWyrk72fPo6yFLQ7A5Z4BLXCTFU',
    [types_1.Networks.Sonic]: 'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/AHj91C4xwYSfyHAnZiMa1pC4ZwRtzqG3QGVyJchEsJAC',
    [types_1.Networks.Linea]: '',
};
exports.BLOCKS_SUBGRAPH_URL = {
    [types_1.Networks.Ropsten]: '',
    [types_1.Networks.Mainnet]: 'https://api.thegraph.com/subgraphs/name/blocklytics/ethereum-blocks',
    [types_1.Networks.Polygon]: 'https://api.thegraph.com/subgraphs/name/matthewlilley/polygon-blocks',
    [types_1.Networks.Arbitrum]: 'https://api.thegraph.com/subgraphs/name/sushiswap/arbitrum-blocks',
    [types_1.Networks.Avalanche]: 'https://api.thegraph.com/subgraphs/name/dasconnor/avalanche-blocks',
    [types_1.Networks.Moonriver]: 'https://api.thegraph.com/subgraphs/name/sushiswap/moonriver-blocks',
    [types_1.Networks.Aurora]: '',
    [types_1.Networks.Cronos]: '',
    [types_1.Networks.Fantom]: 'https://gateway.thegraph.com/api/031cf65e6bf1e03a781f69aeba9770d2/subgraphs/id/3drjZDpA9hAuYGA19ttEkhW432mVe2XHy5YarBDVYHbz',
    [types_1.Networks.Canto]: 'https://api.impermax.finance/subgraphs/name/blocklytics/canto-blocks',
    [types_1.Networks.ZksyncEra]: 'https://api.impermax.finance/subgraphs/name/blocklytics/canto-blocks',
    [types_1.Networks.Blast]: '',
    [types_1.Networks.Harmony]: '',
    [types_1.Networks.Moonbeam]: '',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Base]: '',
    [types_1.Networks.Mantle]: '',
    [types_1.Networks.Scroll]: '',
    [types_1.Networks.Real]: '',
    [types_1.Networks.Optimism]: '',
    [types_1.Networks.Sonic]: '',
    [types_1.Networks.Linea]: '',
};
exports.XIMX_SUBGRAPH_URL = "https://api.thegraph.com/subgraphs/name/impermax-finance/imx-staking";
exports.CONFIG_MANAGER_SUBGRAPH_URL = {
    [types_1.Networks.Ropsten]: '',
    [types_1.Networks.Mainnet]: '',
    [types_1.Networks.Polygon]: 'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/42W3457WecJ4foXk3tBeVpmX8MUHS3L8qXvUvhDSE6p2',
    [types_1.Networks.Arbitrum]: '',
    [types_1.Networks.Avalanche]: '',
    [types_1.Networks.Moonriver]: '',
    [types_1.Networks.Aurora]: '',
    [types_1.Networks.Cronos]: '',
    [types_1.Networks.Fantom]: 'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/D6WHTfFEaUkHyLavPQM5BcivWYMe41Aj6PbdaKhKdfUm',
    [types_1.Networks.Canto]: '',
    [types_1.Networks.ZksyncEra]: '',
    [types_1.Networks.Harmony]: '',
    [types_1.Networks.Moonbeam]: '',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Blast]: 'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/2ARmGYURb2DAHxfJeA1fhVUDeJpHSvCoJTDiBfmTvESN',
    [types_1.Networks.Scroll]: 'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/9vmJatgwfrm7MMWXy3MhAZ2bsbrbbHzik9q9f5hfzZE9',
    [types_1.Networks.Base]: 'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/6y4Bb2KSFsqyjbARM8EpKkqFRt62ELasVCVckg2bv7jB',
    [types_1.Networks.Optimism]: 'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/GWFrv8MNg5fpD19fxdu32G1Wt6om8qb1wbacpgHDyvC8',
    [types_1.Networks.Real]: 'https://api.goldsky.com/api/public/project_cm2d5q4l4w31601vz4swb3vmi/subgraphs/impermax-config-manager-real/1.0/gn',
    [types_1.Networks.Sonic]: 'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/DqzQAecRNGsoRgwVre16Fha9XTPFf9QBo8iZxubysy2x',
    [types_1.Networks.Linea]: 'https://gateway.thegraph.com/api/1350441d268f171aeb0934412dfadf3b/subgraphs/id/CKu5kt4M1p2ELhn7cef9ZjE9igMH2icv3mzBepEdNPRz',
};
exports.WHITELIST_SUBGRAPH_URL = {
    [types_1.Networks.Ropsten]: '',
    [types_1.Networks.Mainnet]: '',
    [types_1.Networks.Polygon]: 'https://api.studio.thegraph.com/query/46041/impermax-whitelist-polygon/v0.0.1',
    [types_1.Networks.Arbitrum]: '',
    [types_1.Networks.Avalanche]: '',
    [types_1.Networks.Moonriver]: '',
    [types_1.Networks.Aurora]: '',
    [types_1.Networks.Cronos]: '',
    [types_1.Networks.Fantom]: '',
    [types_1.Networks.Canto]: '',
    [types_1.Networks.ZksyncEra]: '',
    [types_1.Networks.Harmony]: '',
    [types_1.Networks.Moonbeam]: '',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Mantle]: '',
    [types_1.Networks.Base]: 'https://api.studio.thegraph.com/query/46041/impermax-whitelist-base/v0.0.1',
};
